angular
	.module 'App.Directive'
	.directive 'imageSrc', ->
		restrict: 'A'
		scope:
			imageSrc: '<'
		bindToController: true
		controllerAs: 'imageResizer'
		controller: 'ImageResizerController'

class ImageResizerController extends AbstractController
	@register()
	@inject '$element',
		'$scope'
		'ImageService'

	initialize: ->
		@$scope.$watch 'imageResizer.imageSrc', (newValue) =>
			if newValue?
				@$element[0].src = @ImageService.resize(newValue)
